import { render, staticRenderFns } from "./signUpload.vue?vue&type=template&id=fa30dd80&scoped=true"
import script from "./signUpload.vue?vue&type=script&lang=js"
export * from "./signUpload.vue?vue&type=script&lang=js"
import style0 from "./signUpload.vue?vue&type=style&index=0&id=fa30dd80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa30dd80",
  null
  
)

export default component.exports